import { useEffect, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import { Card } from "@mui/material";
import { fetchData, postData, putData } from "../../../Utils/Baseurl";
import { useLocation, useNavigate } from "react-router-dom";
import { useLoading } from "../../../../context/loadingcontext";
import { useSnackbar } from "../../../../components/SnackbarProvider";
import { useAuth } from "../../../../context/AuthContext";
import { Stepper } from "../../../../components/stepper";
import FirstComponent from "./components/FirstComponent";
import SecondComponent from "./components/SecondComponent";
import { ThirdComponent } from "./components/ThirdComponent";

const CreateMeeting = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const { showSnackbar } = useSnackbar();
  const [masterData, setMasterData] = useState({
    manager: [],
  });
  const { setCirleLoading } = useLoading();
  const [pages, setPages] = useState({
    view: false,
    edit: false,
    id: "",
  });
  const [projectNameOption, setProjectNameOption] = useState([]);
  const [value, setValue] = useState(0);
  const [meetingData, setMeetingData] = useState({
    meetingProject: "",
    meetingTitle: "",
    meetingDate: "",
    meetingStartTime: "",
    meetingEndTime: "",
    meetingAganta: "",
    participant: [],
    meetingAttachment: "",
    summary: [],
    points: "",
    mom: [],
    meetingProjectStatus: "unchecked",
    meetingTitleStatus: "unchecked",
    meetingDateStatus: "unchecked",
    meetingStartTimeStatus: "unchecked",
    meetingEndTimeStatus: "unchecked",
    meetingAgantaStatus: "unchecked",
    participantStatus: "unchecked",
    summaryStatus: "unchecked",
  });

  console.log(meetingData, 'meetingData')

  const [actionItem, setActionItem] = useState(false);


  useEffect(() => {
    getMangerList();
    fetchProjectData();
  }, []);

  useEffect(() => {
    const state = location.state;

    if (state) {
      if (state.type === "view") {
        setPages({ view: true, edit: false });
      } else if (state.type === "edit") {
        setPages({ view: false, edit: true });
      } else {
        setPages({ view: false, edit: false });
      }
      viewEmployee(state.data);
    } else {
      setPages({ view: false, edit: false });
    }
  }, [location]);

  const fetchProjectData = async () => {
    const formData = new FormData();
    formData.append("user_id", currentUser?.id);
    try {
      const res = await fetchData("/api/project/");
      if (res?.status) {
        setProjectNameOption(res?.data);
      } else {
        setProjectNameOption([]);
      }
    } catch (err) {
      console.log(err);

    }
  };
  //   Get Manger List

  const getMangerList = async () => {
    try {
      const response = await fetchData("api/create_user/");

      if (response?.status && Array.isArray(response.data)) {
        setMasterData((pre) => ({
          ...pre,
          manager: response?.data?.map((item, ind) => ({
            label: `${item?.employee_name} - ${item?.team?.team_name}`,
            value: item?.id,
          })),
        }));
      } else {
        setMasterData((pre) => ({
          ...pre,
          manager: [],
        }));
      }
    } catch (error) {
      console.error("Error while fetching role list:", error);
      setMasterData((pre) => ({
        ...pre,
        manager: [],
      }));
    }
  };

  const createMeeting = async () => {

    if (actionItem) {
      showSnackbar("Action item is entered. Please add the action item", "error");
      return;
    }

    setCirleLoading(true);

    const formdata = {
      project: meetingData?.meetingProject?.value,
      meeting_title: meetingData?.meetingTitle,
      meeting_date: meetingData?.meetingDate,
      meeting_start_time: meetingData?.meetingStartTime,
      meeting_end_time: meetingData?.meetingEndTime,
      user_id: currentUser?.id,
      agenda: meetingData?.meetingAganta,
      participants: meetingData?.participant?.map((item, ind) => ({
        id: +item?.value,
        name: item?.label,
      })),
      summary_of_discussion: meetingData?.summary?.map((item, ind) => ({
        [`no:${ind + 1}`]: item,
      })),
      mom_action_items: meetingData?.mom?.map((item, ind) => ({
        assignee_id: +item?.assign?.value,
        action_item: item?.items,
        start_date: item?.startDate,
        end_date: item?.endDate,
      })),
    };

    try {
      let response;
      if (pages.edit) {
        response = await putData(
          `api/meeting/${location.state?.data?.id}/`,
          formdata
        );
      } else {
        response = await postData("api/meeting/", formdata);
      }

      if (response.status) {
        showSnackbar(response?.message, "success");
        navigate("/record-mom");
      } else {
        showSnackbar(response?.message, "error");
      }
    } catch (error) {
      console.log(error);

      let message = "An unexpected error occurred";

      if (error?.response?.status === 400 && error?.response?.data?.message) {
        const errorData = error.response.data.message;

        if (typeof errorData === "object") {
          message = Object.entries(errorData)
            .map(([field, errors]) => `${field}: ${errors.join(", ")}`)
            .join("\n");
        } else {
          message = errorData;
        }
      } else if (error?.message) {
        message = error.message;
      }

      showSnackbar(message, "error");
    } finally {
      setCirleLoading(false);
    }
  };

  //  View Emplyoee
  const viewEmployee = async (row) => {
    setCirleLoading(true);
    try {
      const data = location?.state?.data?.allData;

      setMeetingData((pre) => ({
        ...pre,
        meetingProject: {
          label: data?.project_name,
          value: data?.project,
        },
        meetingTitle: data?.meeting_title,
        meetingDate: data?.meeting_date,
        meetingStartTime: data?.meeting_start_time,
        meetingEndTime: data?.meeting_end_time,
        meetingAganta: data?.agenda,
        participant: data?.participants?.map((item) => ({
          label: item?.name,
          value: item?.id,
        })),
        summary: data?.summary_of_discussion?.map((item) => {
          const value = Object.values(item)?.[0];
          return value;
        }),
        mom: data?.tasks?.map((item) => ({
          startDate: item?.start_date,
          endDate: item?.end_date,
          items: item?.action_item,
          assign: {
            value: item?.assignee,
            label: item?.assignee_name,
          },
        })),
        meetingProjectStatus: "success",
        meetingTitleStatus: "success",
        meetingDateStatus: "success",
        meetingStartTimeStatus: "success",
        meetingEndTimeStatus: "success",
        meetingAgantaStatus: "success",
        participantStatus: "success",
        summaryStatus: "success",
      }));
    } catch (error) {
      console.error("Error fetching employee data:", error);
    } finally {
      setCirleLoading(false);
    }
  };

  const handleMultipleSelect = (event, newValue) => {
    setMeetingData({
      ...meetingData,
      participant: newValue,
    });
  };
  // handle onchange function
  const handleChange = (event, selectEvent) => {
    let meetingDatas = { ...meetingData };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "meetingProject") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          meetingDatas[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          meetingDatas[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      meetingDatas[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "meetingTitle":
          {
            const alphaNLengthRegex = new RegExp("^[A-Za-z0-9!@#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>/?`~\\s]{1,100}$");

            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              meetingDatas[event.target.name + "Status"] = "success";
            } else {
              meetingDatas[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "meetingDate":
          if (event.target.value) {
            meetingDatas[event.target.name + "Status"] = "success";
          } else {
            meetingDatas[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
          break;
        case "meetingStartTime":
          if (event.target.value) {
            meetingDatas[event.target.name + "Status"] = "success";
          } else {
            meetingDatas[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
          break;
        case "meetingEndTime":
          if (event.target.value) {
            meetingDatas[event.target.name + "Status"] = "success";
          } else {
            meetingDatas[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
          break;
        case "meetingAganta":
          {
            const alphaNLengthRegex = new RegExp("^[a-zA-Z0-9 !@#$%^&*()_+\\-={}\\[\\]:;\"'<>,.?/|\\\\]{1,250}$");

            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              meetingDatas[event.target.name + "Status"] = "success";
            } else {
              meetingDatas[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      meetingDatas[event.target.name] = event.target.value;
    }

    setMeetingData(meetingDatas);
  };

  // handle disabled function
  const disabledFunction = () => {
    let disabled;

    if (
      meetingData.meetingProjectStatus === "success" &&
      meetingData.meetingTitleStatus === "success" &&
      meetingData.meetingDateStatus === "success" &&
      meetingData.meetingStartTimeStatus === "success" &&
      meetingData.meetingEndTimeStatus === "success" &&
      meetingData?.meetingAgantaStatus === "success" &&
      meetingData?.participantStatus?.length > 0 &&
      meetingData?.summary?.length > 0 &&
      meetingData?.mom?.length > 0
    ) {
      disabled = false;
    } else {
      disabled = true;
    }
    return disabled;
  };

  const stepper = ["Mom Details", "Summary", "Actions"];
  const handleIncrement = () => {
    if (value < 2) {
      setValue((prev) => prev + 1);
    }
  };

  const handleDecrement = () => {
    if (0 < value) {
      setValue((prev) => prev - 1);
    }
  };
  return (
    <DashboardLayout>
      <Card style={{ minHeight: "90vh" }}>
        <div style={{ margin: "15px" }}>
          <Stepper stepper={stepper} active={value} setActive={setValue} />
        </div>
        {value === 0 && (
          <FirstComponent
            meetingData={meetingData}
            handleChange={handleChange}
            setMeetingData={setMeetingData}
            projectNameOption={projectNameOption}
            pages={pages}
            masterData={masterData}
            handleMultipleSelect={handleMultipleSelect}
          />
        )}
        {value === 1 && (
          <SecondComponent
            meetingData={meetingData}
            setMeetingData={setMeetingData}
            handleChange={handleChange}
            projectNameOption={projectNameOption}
            pages={pages}
            masterData={masterData}
            handleMultipleSelect={handleMultipleSelect}
          />
        )}
        {value === 2 && (
          <ThirdComponent
            meetingData={meetingData}
            setMeetingData={setMeetingData}
            handleChange={handleChange}
            projectNameOption={projectNameOption}
            pages={pages}
            masterData={masterData}
            handleMultipleSelect={handleMultipleSelect}
            setActionItem={setActionItem}
          />
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "5px 0px",
          }}
        >
          <div>
            {value !== 0 && (
              <button
                className="steperButton"
                style={{
                  backgroundColor: " rgba(237, 236, 239, 1)",
                  color: "#3F51B5d4",
                  padding: "10px 30px",
                  cursor: value === 0 ? "not-allowed" : "pointer",
                  marginRight: "10px",
                  borderRadius: "10px",
                  border: "none",
                  fontWeight: "600",
                  fontSize: "18px",
                }}
                onClick={handleDecrement}
                disabled={value === 0}
              >
                Back
              </button>
            )}
            {value !== 2 && (
              <button
                className="steperButton"
                style={{
                  backgroundColor: "#3F51B5d4",
                  color: "white",
                  cursor: value === 3 ? "not-allowed" : "pointer",
                  padding: "10px 30px",
                  marginRight: "10px",
                  borderRadius: "10px",
                  border: "none",
                  fontWeight: "600",
                  fontSize: "18px",
                }}
                onClick={handleIncrement}
                disabled={value === 3}
              >
                Next
              </button>
            )}
            {value === 2 && !pages?.view && (
              <button
                className="steperButton"
                style={{
                  backgroundColor: "#3F51B5d4",
                  color: "white",
                  cursor: value === 0 ? "not-allowed" : "pointer",
                  padding: "10px 30px",
                  marginRight: "10px",
                  borderRadius: "10px",
                  border: "none",
                  fontWeight: "600",
                  fontSize: "18px",
                  opacity: disabledFunction() ? "50%" : "100",
                }}
                onClick={() => createMeeting()}
                disabled={disabledFunction()}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </Card>
    </DashboardLayout>
  );
};

export default CreateMeeting;
